import { Link } from "react-router-dom";
import type { Post } from "@/mocks/posts";
import PostCard from "@/components/feature/PostCard";
import HotRanking from "@/components/feature/HotRanking";

type PostSidebarProps = {
  related: Post[];
};

export default function PostSidebar({ related }: PostSidebarProps) {
  return (
    <aside className="lg:col-span-4">
      <div className="lg:sticky lg:top-28 space-y-5">
        <div className="bg-primary-50 border border-primary-200 rounded-lg p-5">
          <h3 className="font-heading font-bold text-base text-primary-900 flex items-center gap-2">
            <i className="ri-notification-3-line" aria-hidden="true"></i>
            追更这个瓜
          </h3>
          <p className="mt-2 text-sm text-primary-800 leading-relaxed">
            留下邮箱，我们会在话题有后续进展时把更新推给你，也可以在爆料列表蹲守新增内容。
          </p>
          <Link
            to="/contact"
            className="mt-4 inline-flex items-center gap-2 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            订阅更新
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
        </div>

        {related.length > 0 && (
          <div className="bg-background-100 border border-background-200 rounded-lg p-5">
            <h3 className="font-heading font-bold text-base text-foreground-950 mb-4">相关推荐</h3>
            <div className="space-y-4">
              {related.map((post) => (
                <PostCard key={post.id} post={post} variant="compact" />
              ))}
            </div>
          </div>
        )}

        <HotRanking limit={5} />
      </div>
    </aside>
  );
}